// src/data/diagnosticQuestions.js

export const DIAGNOSTIC_QUESTIONS = [
  // --- LEVEL A1 (Beginner) ---
  {
    id: 1,
    level: "A1",
    question: "Select the correct form: 'She _____ from Spain.'",
    options: ["is", "are", "am", "be"],
    correctAnswer: "is"
  },
  {
    id: 2,
    level: "A1",
    question: "Complete the sentence: 'I _____ breakfast at 7:00 AM.'",
    options: ["eat usually", "usually eat", "eats usually", "eating"],
    correctAnswer: "usually eat"
  },
  
  // --- LEVEL A2 (Elementary) ---
  {
    id: 3,
    level: "A2",
    question: "Which sentence is correct?",
    options: [
      "I didn't went to the party.",
      "I didn't go to the party.",
      "I no went to the party.",
      "I haven't gone to the party yesterday."
    ],
    correctAnswer: "I didn't go to the party."
  },
  
  // --- LEVEL B1 (Intermediate) ---
  {
    id: 4,
    level: "B1",
    question: "If I _____ you, I would accept the offer.",
    options: ["was", "were", "am", "have been"],
    correctAnswer: "were"
  },
  
  // --- LEVEL B2 (Upper Intermediate) ---
  {
    id: 5,
    level: "B2",
    question: "The project was _____ due to a lack of funding.",
    options: ["called off", "called out", "called in", "called up"],
    correctAnswer: "called off"
  },

  // --- LEVEL C1 (Advanced) ---
  {
    id: 6,
    level: "C1",
    question: "Choose the synonym for 'ubiquitous':",
    options: ["Rare", "Omnipresent", "Unique", "Obsolete"],
    correctAnswer: "Omnipresent"
  }
  // ... You should add about 20-30 questions here covering all levels
];

export const CEFR_LEVELS = [
  { score: 0, label: "A1 (Beginner)", description: "Can understand basic phrases and everyday expressions." },
  { score: 20, label: "A2 (Elementary)", description: "Can communicate in simple and routine tasks." },
  { score: 40, label: "B1 (Intermediate)", description: "Can deal with most situations while travelling." },
  { score: 60, label: "B2 (Upper Intermediate)", description: "Can interact with a degree of fluency and spontaneity." },
  { score: 80, label: "C1 (Advanced)", description: "Can use language flexibly and effectively for professional purposes." },
  { score: 100, label: "C2 (Mastery)", description: "Can understand with ease virtually everything heard or read." }
];